import axios from 'axios';
export const FETCH_CRMREFERENCEDATA_BEGIN = 'FETCH_CRMREFERENCEDATA_BEGIN';
export const FETCH_CRMREFERENCEDATA_SUCCESS = 'FETCH_CRMREFERENCEDATA_SUCCESS';
export const FETCH_CRMREFERENCEDATA_FAILURE = 'FETCH_CRMREFERENCEDATA_FAILURE';

export const fetchCrmReferenceDataBegin = () => ({
    type: FETCH_CRMREFERENCEDATA_BEGIN
});

export const fetchCrmReferenceDataSuccess = response => ({
    type: FETCH_CRMREFERENCEDATA_SUCCESS,
    payload: response
});

export const fetchCrmReferenceDataFailure = error => ({
    type: FETCH_CRMREFERENCEDATA_FAILURE,
    payload: { error }
});


export const getCrmReferenceData = (webappurlForms, accessToken, referenceDataType) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        dispatch(fetchCrmReferenceDataBegin());

        return axios.post(webappurlForms + "/api/myCASA/Forms/GetReferenceDataTypes/v1", { type: referenceDataType}, options)
            .then(response => {
                if (Object.keys(response.data).length > 0) {
                    return dispatch(fetchCrmReferenceDataSuccess(response.data));
                } 
                return dispatch(fetchCrmReferenceDataFailure("Unable to fetch reference data"));
            })
            .catch(error => {
                return dispatch(fetchCrmReferenceDataFailure(error.response ? error.response.data.errors : error));
            });
    };
}

export const getDroneCrmReferenceData = (webappurlForms, accessToken, referenceDataType, referenceDataCode = null) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        dispatch(fetchCrmReferenceDataBegin());

        return axios.post(webappurlForms + "/api/myCASA/Forms/drone/GetReferenceDataTypes/v1", { type: referenceDataType, code: referenceDataCode }, options)
            .then(response => {
                if (Object.keys(response.data).length > 0) {
                    return dispatch(fetchCrmReferenceDataSuccess(response.data));
                } 
                return dispatch(fetchCrmReferenceDataFailure("Unable to fetch reference data"));
            })
            .catch(error => {
                return dispatch(fetchCrmReferenceDataFailure(error.response ? error.response.data.errors : error));
            });
    };
}